module.exports = __webpack_public_path__ + "static/media/hft.e657091c.jpg";